import { Checkbox, DataHeader, DataSource, Layout, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutExciseTaxControl extends Layout {
    checkboxCreateOrdersTaxable: Checkbox;
    checkboxIsActive: Checkbox;
    dataheaderExciseTaxControl: DataHeader;
    sourceExcisetaxCode: DataSource;
    sourceExcisetaxControl: DataSource;
    sourceExcisetaxRate: DataSource;
    tabCodes: Tab;
    tabGeneral: Tab;
    tabRates: Tab;
    tableCodes: Table;
    tableRates: Table;
    tabsetExciseTaxControl: Tabset;
    textboxBusinessIdNumber: Textbox;
    textboxBusinessNumber: Textbox;
    textboxQuebecNumber: Textbox;
}
